/**
 * @generated SignedSource<<49f06d405fb7678fba181372914d80e7>>
 * @relayHash ea3e49347413e8bf30ce93d8f158104f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 459030a25b00b200f0758055644870f9f250c56ce6625e65bf7655d4feb38501

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { PlaybookListQuery } from './PlaybookListQuery.graphql';

const node: PreloadableConcreteRequest<PlaybookListQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "459030a25b00b200f0758055644870f9f250c56ce6625e65bf7655d4feb38501",
    "metadata": {},
    "name": "PlaybookListQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
